// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\"></wt-loading-panel> <div class=\"fill padded-control last-processed-timeline\"> <svg width=\"0\" height=\"0\"></svg> </div> </div>";
// Exports
module.exports = code;